import { useState } from "react";
import { useWeb3Modal } from "@web3modal/wagmi/react";
import { useAccount, useDisconnect, useSendTransaction } from "wagmi";

function App() {
  const { open } = useWeb3Modal();
  const { address, isConnected } = useAccount();
  const { disconnect } = useDisconnect();

  const [contractAddress, setContractAddress] = useState("");
  const [txData, setTxData] = useState("");
  const [message, setMessage] = useState("Connect your wallet to get started.");

  const { isPending, sendTransaction } = useSendTransaction({
    onSuccess: (data) => {
      setMessage(
        `Transaction sent! Hash: ${data}. Waiting for confirmation...`,
      );
      // In a real app, you'd use wagmi's useWaitForTransactionReceipt here
      // For simplicity, we'll just show the hash.
    },
    onError: (error) => {
      setMessage(`Error: ${error.shortMessage}`);
    },
  });

  const handleSendTransaction = () => {
    if (!contractAddress || !txData) {
      setMessage("Contract address and data cannot be empty.");
      return;
    }

    // Basic validation for hex string
    if (!/^0x[0-9a-fA-F]*$/.test(txData)) {
      setMessage("Transaction data must be a valid hex string (e.g., 0x...)");
      return;
    }

    sendTransaction({
      to: contractAddress,
      data: txData, // Already a hex string from user input
    });
  };

  const formatAddress = (addr) => {
    return addr
      ? `${addr.substring(0, 6)}...${addr.substring(addr.length - 4)}`
      : "";
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            RIVER3 DApp
          </a>
          {isConnected && (
            <span className="navbar-text me-3 text-white">
              {formatAddress(address)}
            </span>
          )}
          {!isConnected ? (
            <button className="btn btn-primary" onClick={() => open()}>
              Connect Wallet
            </button>
          ) : (
            <button
              className="btn btn-outline-secondary"
              onClick={() => disconnect()}
            >
              Disconnect
            </button>
          )}
        </div>
      </nav>

      <div className="container mt-5">
        <div className="row">
          <div className="col-md-8 offset-md-2">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Send BSC Transaction</h5>
                <p className="card-text text-muted">
                  {isPending ? "Waiting for signature..." : message}
                </p>

                <div className="mb-3">
                  <label htmlFor="contractAddress" className="form-label">
                    Contract Address
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="contractAddress"
                    placeholder="0x..."
                    value={contractAddress}
                    onChange={(e) => setContractAddress(e.target.value)}
                    disabled={!isConnected}
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="txData" className="form-label">
                    Transaction Data (Hex)
                  </label>
                  <textarea
                    className="form-control"
                    id="txData"
                    rows="3"
                    placeholder="0x..."
                    value={txData}
                    onChange={(e) => setTxData(e.target.value)}
                    disabled={!isConnected}
                  ></textarea>
                </div>

                <button
                  className="btn btn-success w-100"
                  onClick={handleSendTransaction}
                  disabled={
                    !isConnected || isPending || !contractAddress || !txData
                  }
                >
                  {isPending ? "Sending..." : "Send Transaction"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
